// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menuWrapper--1lQ9UwXe {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 110;\n}\n\n.dropdownMenu--1doKJ4bi {\n  width: -webkit-fit-content;\n  width: fit-content;\n  width: -moz-fit-content;\n}\n\n.pasteNameWrapper--dqvLhpfR {\n  color: var(--text-color-disabled);\n  margin-left: 0.5em;\n}\n\n.pasteName--3IzuqvAP {\n  display: inline-block;\n  vertical-align: bottom;\n  max-width: 8em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuWrapper": "menuWrapper--1lQ9UwXe",
	"dropdownMenu": "dropdownMenu--1doKJ4bi",
	"pasteNameWrapper": "pasteNameWrapper--dqvLhpfR",
	"pasteName": "pasteName--3IzuqvAP"
};
export default ___CSS_LOADER_EXPORT___;
